const ARTICLES_URLS = {
  articles: 'api/v1/articles/:id'
};

export default (api) => ({
  getAll: () => api.get(ARTICLES_URLS.articles),
  getOne: (id) => api.get(ARTICLES_URLS.articles, { url_params: { id } })
});
